<template>
	<TemplateDetail v-bind="$props">
		<slot />
	</TemplateDetail>
</template>

<script lang="ts" setup>
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import type { ButtonType } from '#base/core/types/ButtonType';

defineProps<{
	breadcrumbs?: BreadcrumbsType;
	isSales?: boolean;
	title: string;
	description: string;
	button?: ButtonType;
}>();
</script>
